// extracted by mini-css-extract-plugin
export default {"image_list":"Article_image_list__cdD42","splide":"Article_splide__4Ityo","image":"Article_image__wlHGl","icon":"Article_icon__X-hFD"};